import { ISelectItem } from '@lla-platform/core/core-ui'

export enum ObjectiveCategory {
  Sales = 'Sales',
  Cars = 'Cars',
  CarBonus = 'CarBonus',
  AverageTicket = 'AverageTicket',
  Tires = 'Tires',
  Alignments = 'Alignments',
  Fluids = 'Fluids',
  Brakes = 'Brakes',
  GrossProfit = 'GrossProfit',
  NewInvoices = 'NewInvoices',
  FriendsInvoices = 'FriendsInvoices',
  AdvocatesInvoices = 'AdvocatesInvoices'
}

export const ObjectiveCategoryToLabel: { [key: string]: string } = {
  Sales: 'Sales',
  Cars: 'Car Count',
  CarBonus: 'Car Bonus',
  AverageTicket: 'Average Ticket',
  Tires: 'Tires',
  Alignments: 'Alignments',
  Fluids: 'Fluids',
  Brakes: 'Brakes',
  GrossProfit: 'Gross Profit',
  NewInvoices: 'New Invoices',
  FriendsInvoices: 'Friends Invoices',
  AdvocatesInvoices: 'Advocates Invoices'
}

export const ObjectiveCategoryToSign: { [key: string]: string } = {
  Sales: '$',
  Cars: '',
  CarBonus: '',
  AverageTicket: '$',
  Tires: '',
  Alignments: '',
  Fluids: '$',
  Brakes: '$',
  GrossProfit: '%',
  NewInvoices: '',
  FriendsInvoices: '',
  AdvocatesInvoices: ''
}

export const ObjectiveCategoryItems: ISelectItem[] = [
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Sales],
    value: ObjectiveCategory.Sales
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Cars],
    value: ObjectiveCategory.Cars
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.CarBonus],
    value: ObjectiveCategory.CarBonus
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.AverageTicket],
    value: ObjectiveCategory.AverageTicket
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Tires],
    value: ObjectiveCategory.Tires
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Alignments],
    value: ObjectiveCategory.Alignments
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Fluids],
    value: ObjectiveCategory.Fluids
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.Brakes],
    value: ObjectiveCategory.Brakes
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.GrossProfit],
    value: ObjectiveCategory.GrossProfit
  }
]

export const BCapObjectiveCategoryItems: ISelectItem[] = [
  ...ObjectiveCategoryItems,
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.NewInvoices],
    value: ObjectiveCategory.NewInvoices
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.FriendsInvoices],
    value: ObjectiveCategory.FriendsInvoices
  },
  {
    label: ObjectiveCategoryToLabel[ObjectiveCategory.AdvocatesInvoices],
    value: ObjectiveCategory.AdvocatesInvoices
  }
]
